import React from 'react';
import * as Animatable from 'react-native-animatable';
import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import Tapper from '@src/components/Tapper';

type Props = {
  liked?: boolean;
  onLike?: () => void;
  onTap?: () => void;
  children: React.ReactNode;
};

const Container = styled.View`
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled(Animatable.View)`
  position: absolute;
  opacity: 0;
`;

const LikeIcon = styled(FontIcon).attrs({
  name: 'heart-o',
  size: 100,
  color: 'white',
})``;

const Component: React.FC<Props> = ({ onLike, liked, onTap, children }) => {
  const ref = React.useRef<Animatable.View>();
  const handleDoubleTap = React.useCallback(async () => {
    if (ref.current) {
      ref.current.stopAnimation();
      if (!liked) {
        onLike?.();
      }
      await ref.current.bounceIn?.();
      await ref.current.bounceOut?.();
    }
  }, [liked, onLike]);

  return (
    <Tapper onSingleTap={onTap} onDoubleTap={handleDoubleTap}>
      <Container>
        {children}
        <IconWrapper
          // @ts-ignore
          ref={ref}
          pointerEvents="none"
        >
          <LikeIcon />
        </IconWrapper>
      </Container>
    </Tapper>
  );
};

Component.displayName = 'Likable';

export default React.memo(Component);
